import { X } from "lucide-react";

function ReadingDetailsModal({
    reading,
    onClose
}) {
    return (
        <div className="
            fixed inset-0
            bg-black/60
            backdrop-blur-sm
            flex items-center justify-center
            z-50 p-4
        ">
            <div className="
                bg-white
                w-full max-w-[1000px]
                mx-4 rounded-3xl
                border border-border
                max-h-[90vh] overflow-y-auto
            ">

                <div className="
                    px-4 md:px-8 py-4 md:py-6
                    border-b border-border
                ">
                    <div className="flex justify-between items-start gap-4">

                        <div>
                            <p className="
                                text-xs
                                uppercase
                                tracking-[3px]
                                text-electricBlue
                            ">
                                Historical Reading
                            </p>

                            <h2 className="text-xl md:text-2xl font-bold mt-2">
                                {reading.DeviceId}
                            </h2>

                            <p className="text-textSecondary">
                                {reading.DiviceName}
                            </p>

                            <p className="mt-2 text-sm text-textSecondary">
                                {reading.Ddate} • {reading.Dtime}
                            </p>
                        </div>

                        <button onClick={onClose}>
                            <X />
                        </button>

                    </div>
                </div>

                <div className="
                    p-4 md:p-8
                    grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4
                    gap-4
                ">

                    <Metric label="Voltage AB" value={reading.VoltageAB} />
                    <Metric label="Voltage BC" value={reading.VoltageBC} />
                    <Metric label="Voltage CA" value={reading.VoltageCA} />

                    <Metric label="Voltage AN" value={reading.VoltageAN} />
                    <Metric label="Voltage BN" value={reading.VoltageBN} />
                    <Metric label="Voltage CN" value={reading.VoltageCN} />

                    <Metric label="Current A" value={reading.CurrentA} />
                    <Metric label="Current B" value={reading.CurrentB} />
                    <Metric label="Current C" value={reading.CurrentC} />
                    <Metric label="Current N" value={reading.CurrentN} />

                    <Metric
                        label="Active Power"
                        value={reading.TotalActivePowerKW}
                    />

                    <Metric
                        label="Reactive Power"
                        value={reading.TotalReactivePowerKVAR}
                    />

                    <Metric
                        label="Apparent Power"
                        value={reading.TotalApparentPowerKVA}
                    />

                    <Metric
                        label="Power Factor"
                        value={reading.PowerFactor}
                    />

                    <Metric
                        label="Frequency"
                        value={reading.FrequencyHz}
                    />

                    <Metric
                        label="Active Energy"
                        value={reading.ActiveEnergyKWh}
                    />

                    <Metric
                        label="Reactive Energy"
                        value={reading.ReactiveEnergyKVARh}
                    />

                </div>

            </div>
        </div>
    );
}

function Metric({ label, value }) {
    return (
        <div className="
            bg-surfaceSoft
            rounded-xl
            p-4
        ">
            <p className="
                text-xs
                text-textSecondary
            ">
                {label}
            </p>

            <p className="
                mt-1
                text-base md:text-lg
                font-bold
                text-textPrimary break-words
            ">
                {value}
            </p>
        </div>
    );
}

export default ReadingDetailsModal;